import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import PlanetLinks from '../../../components/PlanetLinks/PlanetLinks';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import './Transit.scss'



const Transit = () => {
    return(
        <div className="Transit-container">
            <InnerNav/>
            <div className="Transit-content">
                <Zodiac/>

                <div className="planet-header">
                    <h3>Planets Rashi Transit</h3>
                </div>

                <div className="planet-grid">
                    <div className="planet-card">
                        <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/b4/The_Sun_by_the_Atmospheric_Imaging_Assembly_of_NASA%27s_Solar_Dynamics_Observatory_-_20100819.jpg/2146px-The_Sun_by_the_Atmospheric_Imaging_Assembly_of_NASA%27s_Solar_Dynamics_Observatory_-_20100819.jpg" alt="" />
                        <p>Surya Gochar</p>
                    </div>

                     <div className="planet-card">
                        <img src="https://images.pexels.com/photos/47367/full-moon-moon-bright-sky-47367.jpeg" alt="" />
                        <p>Chandra Gochar</p>
                    </div>

                     <div className="planet-card">
                        <img src="https://cdn.britannica.com/64/73464-050-56C80D3A/view-composite-images-Mars-spacecraft-Global-Surveyor-April-1999.jpg?w=200&h=200&c=crop" alt="" />
                        <p>Mangal Gochar</p>
                    </div>

                     <div className="planet-card">
                        <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d9/Mercury_in_color_-_Prockter07-edit1.jpg/330px-Mercury_in_color_-_Prockter07-edit1.jpg" alt="" />
                        <p>Budha Gochar</p>
                    </div>

                     <div className="planet-card">
                        <img src="https://upload.wikimedia.org/wikipedia/commons/e/e2/Jupiter_OPAL_2024.png" alt="" />
                        <p>Guru Gochar</p>
                    </div>

                     <div className="planet-card">
                        <img src="https://static.toiimg.com/thumb/msid-111581483,width-1280,height-720,resizemode-4/111581483.jpg" alt="" />
                        <p>Shukra Gochar</p>
                    </div>
                </div>


                <PlanetLinks/>
            </div>
            <Footer/>
        </div>
    )
}
export default Transit;